export enum TourId {
	onboarding = "onboarding",
}
